









import {ContainerMixin} from 'vue-slicksort';

export default {
    name: 'BaseSortableList',
    components: {},
    props: {
    },
    data() {
        return {};
    },
    mixins: [ContainerMixin],
    methods: {},
};
